export default __webpack_public_path__ + "static/media/byoc-banner-img.3a099422.svg";